import { RootState } from '@store/store'
import { prop } from 'ramda'
import { createSelector } from 'reselect'

import {
  ASSESSMENT,
  ASSESSMENT_ATTEMPT,
  ASSESSMENT_ATTEMPT_DELETE,
  ASSESSMENT_ATTEMPT_ITEM,
  ASSESSMENT_BULK,
  ASSESSMENT_COPY,
  ASSESSMENT_CREATE,
  ASSESSMENT_CRITERIA,
  ASSESSMENT_CRITERIA_LIST,
  ASSESSMENT_CRITERIA_STATUS,
  ASSESSMENT_CRITERIA_TYPES,
  ASSESSMENT_CRITERIA_UPDATE,
  ASSESSMENT_LIST,
  ASSESSMENT_STUDENT,
  ASSESSMENT_STUDENT_CRITERIA_DETAILS,
  ASSESSMENT_STUDENT_UPDATED,
  ASSESSMENT_STUDENT_UPLOAD,
  ASSESSMENT_SUBMIT,
  GLOBAL_STATE,
} from '../constants/actionTypes'

const assessmentsSelector = (state: RootState) => prop(GLOBAL_STATE, state)

export const assessmentSelector = createSelector(assessmentsSelector, data => data[ASSESSMENT])

export const assessmentBulkSelector = createSelector(assessmentsSelector, data => data[ASSESSMENT_BULK])

export const assessmentListSelector = createSelector(assessmentsSelector, data => data[ASSESSMENT_LIST])

export const assessmentAttemptItemSelector = createSelector(assessmentsSelector, data => data[ASSESSMENT_ATTEMPT_ITEM])

export const assessmentCriteriaSelector = createSelector(assessmentsSelector, data => data[ASSESSMENT_CRITERIA])

export const assessmentStudentSelector = createSelector(assessmentsSelector, data => data[ASSESSMENT_STUDENT])

export const assessmentStudentUpdatedSelector = createSelector(
  assessmentsSelector,
  data => data[ASSESSMENT_STUDENT_UPDATED]
)

export const assessmentStudentCriteriaDetailsSelector = createSelector(
  assessmentsSelector,
  data => data[ASSESSMENT_STUDENT_CRITERIA_DETAILS]
)

export const assessmentCreateSelector = createSelector(assessmentsSelector, data => data[ASSESSMENT_CREATE])

export const assessmentAttemptSelector = createSelector(assessmentsSelector, data => data[ASSESSMENT_ATTEMPT])

export const assessmentCopySelector = createSelector(assessmentsSelector, data => data[ASSESSMENT_COPY])

export const assessmentSubmitSelector = createSelector(assessmentsSelector, data => data[ASSESSMENT_SUBMIT])

export const assessmentCriteriaUpdateSelector = createSelector(
  assessmentsSelector,
  data => data[ASSESSMENT_CRITERIA_UPDATE]
)

export const assessmentCriteriaListSelector = createSelector(
  assessmentsSelector,
  data => data[ASSESSMENT_CRITERIA_LIST]
)

export const assessmentCriteriaStatusSelector = createSelector(
  assessmentsSelector,
  data => data[ASSESSMENT_CRITERIA_STATUS]
)

export const assessmentCriteriaTypesSelector = createSelector(
  assessmentsSelector,
  data => data[ASSESSMENT_CRITERIA_TYPES]
)

export const assessmentStudentUploadSelector = createSelector(
  assessmentsSelector,
  data => data[ASSESSMENT_STUDENT_UPLOAD]
)

export const assessmentAttemptDeleteSelector = createSelector(
  assessmentsSelector,
  data => data[ASSESSMENT_ATTEMPT_DELETE]
)

export const assessmentCriteriaListOptionsSelector = createSelector(assessmentCriteriaListSelector, selected => {
  return {
    loading: selected.loading,
    error: selected.error,
    options: Array.isArray(selected.data)
      ? selected.data.map(item => ({ label: item.component_type || '', value: item.id }))
      : [],
  }
})
